import React, { useEffect, useLayoutEffect, useRef, Suspense, lazy } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Clients from './pages/Clients';
import PortfolioRouteSEO from './component/PortfolioRouteSEO';
import { GlobalMediaRevealManager } from './component/ui/MediaReveal';
import WhatsAppButton from './component/WhatsAppButton';
import { setLenis, getLenis } from './lib/lenisBridge';
import usePageTracking from './hooks/usePageTracking';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

if (typeof window !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);
}

const Contact = lazy(() => import('./pages/Contact'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const Service = lazy(() => import('./pages/Service'));
const NewService = lazy(() => import('./pages/NewService'));
const ShopifyDevelopment = lazy(() => import('./pages/Ecommerce/ShopifyDevelopment'));
const ShopifyPlusDevelopment = lazy(() => import('./pages/Ecommerce/ShopifyPlusDevelopment'));
const ShopifyMigration = lazy(() => import('./pages/Ecommerce/ShopifyMigration'));
const ShopifyHeadless = lazy(() => import('./pages/Ecommerce/ShopifyHeadless'));
const Cro = lazy(() => import('./pages/Ecommerce/Cro'));
const StorePerformance = lazy(() => import('./pages/Ecommerce/StorePerformance'));
const AbTesting = lazy(() => import('./pages/Ecommerce/AbTesting'));
const Branding = lazy(() => import('./pages/Design/Branding'));
const UiUx = lazy(() => import('./pages/Design/UiUx'));
const WebDesign = lazy(() => import('./pages/Design/WebDesign'));
const CaseStudyFragstalk = lazy(() => import('./pages/CaseStudyFragstalk'));
const CaseStudyAnandhaas = lazy(() => import('./pages/CaseStudyAnandhaas'));
const CaseStudyFruzo = lazy(() => import('./pages/CaseStudyFruzo'));
const CaseStudyEustress = lazy(() => import('./pages/CaseStudyEustress'));
const CaseStudyAcer = lazy(() => import('./pages/CaseStudyAcer'));
const CaseStudyWaylonSmith = lazy(() => import('./pages/CaseStudyWaylonSmith'));
const CaseStudyOval = lazy(() => import('./pages/CaseStudyOval'));
const CaseStudyAyurmedix3d = lazy(() => import('./pages/CaseStudyAyurmedix3d'));
const CaseStudyGlosense3d = lazy(() => import('./pages/CaseStudyGlosense3d'));
const CaseStudySwara3d = lazy(() => import('./pages/CaseStudySwara3d'));
const CaseStudyMia3d = lazy(() => import('./pages/CaseStudyMia3d'));
const CaseStudyStarScouts3d = lazy(() => import('./pages/CaseStudyStarScouts3d'));
const CaseStudyKitchenCulture3d = lazy(() => import('./pages/CaseStudyKitchenCulture3d'));
const CaseStudyFruzo3d = lazy(() => import('./pages/CaseStudyFruzo3d'));
const CaseStudyOtrix3d = lazy(() => import('./pages/CaseStudyOtrix3d'));
const CaseStudyAliza3d = lazy(() => import('./pages/CaseStudyAliza3d'));
const CaseStudyMyherb3d = lazy(() => import('./pages/CaseStudyMyherb3d'));
const Career = lazy(() => import('./pages/Career'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const PortfolioAnandsweets = lazy(() => import('./pages/PortfolioAnandsweets'));
const ServiceWebDevelopment = lazy(() => import('./pages/ServiceWebDevelopment'));
const ServiceECommerce = lazy(() => import('./pages/ServiceECommerce'));
const ServiceUiUx = lazy(() => import('./pages/ServiceUiUx'));
const ServiceVisualIdentity = lazy(() => import('./pages/ServiceVisualIdentity'));
const ServiceWebDesign = lazy(() => import('./pages/ServiceWebDesign'));
const PortfolioYogabar = lazy(() => import('./pages/PortfolioYogabar'));
const PortfolioNourysh = lazy(() => import('./pages/PortfolioNourysh'));
const PortfolioGiverNutritions = lazy(() => import('./pages/PortfolioGiverNutritions'));
const NotFound = lazy(() => import('./pages/NotFound'));
const ServiceSEO = lazy(() => import('./pages/ServiceSEO'));
const GraphicDesign = lazy(() => import('./pages/Design/GraphicDesign'));
const PackagingDesign = lazy(() => import('./pages/Design/PackagingDesign'));
const ThreeDRendering = lazy(() => import('./pages/Design/ThreeDRendering'));
const MotionGraphics = lazy(() => import('./pages/Design/MotionGraphics'));
const ServiceForStartup = lazy(() => import('./pages/ServiceForStartup'));
const ServiceAbTesting = lazy(() => import('./pages/ServiceAbTesting'));
const PortfolioChhappanbhog = lazy(() => import('./pages/PortfolioChhappanbhog'));
const PortfolioBayla = lazy(() => import('./pages/PortfolioBayla'));
const PortfolioDr_vaidya = lazy(() => import('./pages/PortfolioDr_vaidya'));
const PortfolioPrakruti = lazy(() => import('./pages/PortfolioPrakruti'));
const PortfolioHyFun = lazy(() => import('./pages/PortfolioHyFun'));
const PortfolioHamdard = lazy(() => import('./pages/PortfolioHamdard'));
const PortfolioThenga = lazy(() => import('./pages/PortfolioThenga'));
const PortfolioSportSaber = lazy(() => import('./pages/PortfolioSportSaber'));
const PortfolioShistaka = lazy(() => import('./pages/PortfolioShistaka'));
const Blogs = lazy(() => import('./pages/Blogs'));
const BlogDetail = lazy(() => import('./pages/BlogDetail'));
const Studio = lazy(() => import('./pages/Studio'));
const AboxBranding = lazy(() => import('./pages/AboxBranding'));
const PortfolioDLFilms = lazy(() => import('./pages/PortfolioDLFilms'));
const PortfolioUbar = lazy(() => import('./pages/PortfolioUbar'));
const PortfolioRadheySweet = lazy(() => import('./pages/PortfolioRadheySweet'));
const PortfolioFreshLeaf = lazy(() => import('./pages/PortfolioFreshLeaf'));
const PortfolioHealthoxide = lazy(() => import('./pages/PortfolioHealthoxide'));
const InternationalCampaign = lazy(() => import('./pages/InternationalCampaign'));
const Service3DRender = lazy(() => import('./pages/Service3DRender'));
const InternationalCampaignB = lazy(() => import('./pages/InternationalCampaignB'));
const PortfolioMaaNBaby = lazy(() => import('./pages/PortfolioMaaNBaby'));
const PortfolioGoGrub = lazy(() => import('./pages/PortfolioGoGrub'));
const PortfolioEkkiBekki = lazy(() => import('./pages/PortfolioEkkiBekki'));
const LegalBranding = lazy(() => import('./pages/LegalBranding'));
const PolicyPage = lazy(() => import('./pages/PolicyPage'));
const PortfolioMyPro = lazy(() => import('./pages/PortfolioMyPro'));
const PortfolioTeaToxLife = lazy(() => import('./pages/PortfolioTeaToxLife'));
const ConversionRateOptimization = lazy(() => import('./pages/ConversionRateOptimization'));
const PortfolioAumex = lazy(() => import('./pages/PortfolioAumex'));
const PortfolioGreenFay = lazy(() => import('./pages/PortfolioGreenFay'));
const UITeatoxLife = lazy(() => import('./pages/ui/UITeatoxLife'));
const IndiaCampaign = lazy(() => import('./pages/IndiaCampaign'));
const ThankYou = lazy(() => import('./pages/ThankYou'));
const UITheOne = lazy(() => import('./pages/ui/UITheOne'));
const LabelShishtaka = lazy(() => import('./pages/label/LabelShishtaka'));
const LabelHealingHands = lazy(() => import('./pages/label/LabelHealingHands'));
const LabelNaturare = lazy(() => import('./pages/label/LabelNaturare'));
const LabelMyPro = lazy(() => import('./pages/label/LabelMyPro'));
const LabelAumex = lazy(() => import('./pages/label/LabelAumex'));
const LabelTeatoxLife = lazy(() => import('./pages/label/LabelTeatoxLife'));
const PortfolioPaperClipNCo = lazy(() => import('./pages/PortfolioPaperClipNCo'));
const PortfolioNaturare = lazy(() => import('./pages/PortfolioNaturare'));
const PortfolioFastNFry = lazy(() => import('./pages/PortfolioFastNFry'));
const PortfolioNeoRoots = lazy(() => import('./pages/PortfolioNeoRoots'));
const UIAppleElevators = lazy(() => import('./pages/ui/UIAppleElevators'));
const UILycanPay = lazy(() => import('./pages/ui/UILycanPay'));
const UIHealingHands = lazy(() => import('./pages/ui/UIHealingHands'));
const PortfolioWithin = lazy(() => import('./pages/PortfolioWithin'));
const PortfolioUppercase = lazy(() => import('./pages/PortfolioUppercase'));
const PortfolioOmSweets = lazy(() => import('./pages/PortfolioOmSweets'));
const PortfolioHealingHands = lazy(() => import('./pages/PortfolioHealingHands'));
const PortfolioYoGathiya = lazy(() => import('./pages/PortfolioYoGathiya'));
const PortfolioCodifi = lazy(() => import('./pages/PortfolioCodifi'));
const PortfolioTerahash = lazy(() => import('./pages/PortfolioTerahash'));
const PortfolioKutum = lazy(() => import('./pages/PortfolioKutum'));
const PortfolioArospice = lazy(() => import('./pages/PortfolioArospice'));
const TerahashBranding = lazy(() => import('./pages/TerahashBranding'));
const LabelRas = lazy(() => import('./pages/label/LabelRas'));
const PortfolioFoneNetwork = lazy(() => import('./pages/PortfolioFoneNetwork'));
const PortfolioRepeatGud = lazy(() => import('./pages/PortfolioRepeatGud'));
const PortfolioNurdle = lazy(() => import('./pages/PortfolioNurdle'));
const NouryshBranding = lazy(() => import('./pages/NouryshBranding'));
const PortfolioAuroLab = lazy(() => import('./pages/PortfolioAuroLab'));
const LabelMoody = lazy(() => import('./pages/label/LabelMoody'));
const PortfolioTechnoSport = lazy(() => import('./pages/PortfolioTechnoSport'));
const PortfolioWesterville = lazy(() => import('./pages/PortfolioWesterville'));
const PortfolioMyoaCookies = lazy(() => import('./pages/PortfolioMyoaCookies'));
const PortfolioSparkFusion = lazy(() => import('./pages/PortfolioSparkFusion'));
const PortfolioBontrue = lazy(() => import('./pages/PortfolioBontrue'));
const PortfolioBhagavadGita = lazy(() => import('./pages/PortfolioBhagavadGita'));
const LabelNourysh = lazy(() => import('./pages/label/LabelNourysh'));
const PortfolioWeightManage = lazy(() => import('./pages/PortfolioWeightManage'));
const PortfolioAgarwalBhavanSweets = lazy(() => import('./pages/PortfolioAgarwalBhavanSweets'));
const PortfolioMurariSweet = lazy(() => import('./pages/PortfolioMurariSweet'));
const PortfolioSinglas = lazy(() => import('./pages/PortfolioSinglas'));
const PortfolioSavaniJewellery = lazy(() => import('./pages/PortfolioSavaniJewellery'));
const PortfolioBodyArt = lazy(() => import('./pages/PortfolioBodyArt'));
const PortfolioMia = lazy(() => import('./pages/PortfolioMia'));
const PortfolioGPullaReddySweets = lazy(() => import('./pages/PortfolioGPullaReddySweets'));
const PortfolioChakNow = lazy(() => import('./pages/PortfolioChakNow'));
const PortfolioInstantCashPrice = lazy(() => import('./pages/PortfolioInstantCashPrice'));
const PortfolioRedPalette = lazy(() => import('./pages/PortfolioRedPalette'));
const ShopifyFunnle = lazy(() => import('./pages/ShopifyFunnle'));
const ShopifyFunnleForm = lazy(() => import('./pages/ShopifyFunnleForm'));
const LabelAcnex = lazy(() => import('./pages/label/LabelAcnex'));
const LabelAnthi = lazy(() => import('./pages/label/LabelAnthi'));
const LabelTerahash = lazy(() => import('./pages/label/LabelTerahash'));
const LabelKayura = lazy(() => import('./pages/label/LabelKayura'));
const LabelKutum = lazy(() => import('./pages/label/LabelKutum'));
const LabelMaadico = lazy(() => import('./pages/label/LabelMaadico'));
const LabelMaisonJarin = lazy(() => import('./pages/label/LabelMaisonJarin'));
const LabelMolecule = lazy(() => import('./pages/label/LabelMolecule'));
const LabelCocktails = lazy(() => import('./pages/label/LabelCocktails'));
const LabelRareSuga = lazy(() => import('./pages/label/LabelRareSuga'));
const LabelweightManage = lazy(() => import('./pages/label/LabelweightManage'));
const LabelRasLipstick = lazy(() => import('./pages/label/LabelRasLipstick'));
const LabelElder = lazy(() => import('./pages/label/LabelElder'));
const PortfolioOuterWorld = lazy(() => import('./pages/PortfolioOuterWorld'));
const PortfolioMaisonDeJarin = lazy(() => import('./pages/PortfolioMaisonDeJarin'));
const PortfolioMaadico = lazy(() => import('./pages/PortfolioMaadico'));
const PortfolioTomahawk = lazy(() => import('./pages/PortfolioTomahawk'));
const HealinghandBranding = lazy(() => import('./pages/HealinghandBranding'));
const JivaAyushBranding = lazy(() => import('./pages/JivaAyushBranding'));
const OmnesBranding = lazy(() => import('./pages/OmnesBranding'));
const FastNFryBranding = lazy(() => import('./pages/FastNFryBranding'));
const PortfolioAyurmedix = lazy(() => import('./pages/PortfolioAyurmedix'));
const PortfolioChaykra = lazy(() => import('./pages/PortfolioChaykra'));
const PortfolioWobbIndia = lazy(() => import('./pages/PortfolioWobbIndia'));
const PortfolioSevpoori = lazy(() => import('./pages/PortfolioSevpoori'));
const PortfolioGreatOldDays = lazy(() => import('./pages/PortfolioGreatOldDays'));
const UIGrowthHive = lazy(() => import('./pages/ui/UIGrowthHive'));
const PortfolioSinclairsHotels = lazy(() => import('./pages/PortfolioSinclairsHotels'));
const UIJummbo = lazy(() => import('./pages/ui/UIJummbo'));
const PortfolioShiftEco = lazy(() => import('./pages/PortfolioShiftEco'));
const PortfolioMom = lazy(() => import('./pages/PortfolioMom'));
const LabelCaspianSmartMop = lazy(() => import('./pages/label/LabelCaspianSmartMop'));
const PortfolioGlosense = lazy(() => import('./pages/PortfolioGlosense'));
const CareerDetail = lazy(() => import('./pages/CareerDetail'));
const CareerForm = lazy(() => import('./pages/CareerForm'));
const VeloraBranding = lazy(() => import('./pages/VeloraBranding'));
const LabelOval = lazy(() => import('./pages/label/LabelOval'));
const LabelSuperPlump = lazy(() => import('./pages/label/LabelSuperPlump'));
const PortfolioSilverfied = lazy(() => import('./pages/PortfolioSilverfied'));
const PortfolioElder = lazy(() => import('./pages/PortfolioElder'));
const LabelMyHerb = lazy(() => import('./pages/label/LabelMyHerb'));
const TokyoFixBranding = lazy(() => import('./pages/TokyoFixBranding'));
const OvalBranding = lazy(() => import('./pages/OvalBranding'));
const Branding70pc = lazy(() => import('./pages/70pcBranding'));
const TypicalBranding = lazy(() => import('./pages/TypicalBranding'));
const UIVijayaLaxmiSilk = lazy(() => import('./pages/ui/UIVijayaLaxmiSilk'));

function ScrollToTop({ isStudioRoute }) {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if (isStudioRoute) return;

    const isShopifyFormPage = pathname === '/shopify-growth-agency/get-audit-your-store';

    // Synchronously reset scroll before browser paints the new route
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;

    const lenis = getLenis();
    if (lenis) {
      if (isShopifyFormPage) {
        lenis.stop();
      } else {
        lenis.start();
        lenis.scrollTo(0, { immediate: true });
      }
    }
  }, [pathname, isStudioRoute]);

  useEffect(() => {
    if (isStudioRoute) return;
    const isShopifyFormPage = pathname === '/shopify-growth-agency/get-audit-your-store';

    const lenis = getLenis();
    if (lenis && !isShopifyFormPage) {
      lenis.scrollTo(0, { immediate: true });
    }
    ScrollTrigger.refresh();
  }, [pathname, isStudioRoute]);

  return null;
}

function App() {

  const { pathname } = useLocation();
  const isStudioRoute = pathname.startsWith('/studio');

  // GA4 / GTM virtual page view on every client-side route change
  usePageTracking();
  const lenisRef = useRef(null);

  useEffect(() => {
    if (isStudioRoute) return;

    let destroyed = false;
    let rafId = 0;
    let lenis;
    let setupId = 0;
    // Native scroll below desktop. Do not key off pointer/hover — Windows
    // touchscreens and DevTools report coarse pointer even at desktop widths,
    // which skipped Lenis and broke wheel scrolling.
    const nativeScrollMq = window.matchMedia('(max-width: 1023px)');

    const teardown = () => {
      setupId += 1;
      cancelAnimationFrame(rafId);
      rafId = 0;
      setLenis(null);
      if (lenisRef.current) {
        lenisRef.current.destroy();
        lenisRef.current = null;
      } else if (lenis) {
        lenis.destroy();
      }
      lenis = undefined;
    };

    const setup = () => {
      teardown();
      const id = setupId;
      if (destroyed || nativeScrollMq.matches) return;

      import('@studio-freight/lenis').then(({ default: Lenis }) => {
        if (destroyed || id !== setupId || nativeScrollMq.matches) return;

        lenis = new Lenis({
          duration: 1.5,
          easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
          smooth: true,
          syncTouch: false,
        });

        lenis.on('scroll', ScrollTrigger.update);

        lenisRef.current = lenis;
        setLenis(lenis);

        const isShopifyFormPage = window.location.pathname === '/shopify-growth-agency/get-audit-your-store';
        if (!isShopifyFormPage) {
          lenis.scrollTo(0, { immediate: true });
        }

        function raf(time) {
          lenis.raf(time);
          rafId = requestAnimationFrame(raf);
        }

        rafId = requestAnimationFrame(raf);
      });
    };

    setup();
    nativeScrollMq.addEventListener('change', setup);

    return () => {
      destroyed = true;
      nativeScrollMq.removeEventListener('change', setup);
      teardown();
    };
  }, [isStudioRoute]);

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  // tab text animation
  const originalTitle = useRef(document.title);
  const intervalRef = useRef(null);

  useEffect(() => {
    const messages = ["👋 Come back!", "🥺 We miss you!"];
    let index = 0;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        intervalRef.current = setInterval(() => {
          document.title = messages[index % messages.length];
          index++;
        }, 1000);
      } else {
        clearInterval(intervalRef.current);
        document.title = originalTitle.current;
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearInterval(intervalRef.current);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <>
      {isStudioRoute ? (
        <Suspense fallback={null}>
          <Routes>
            <Route path="/studio/*" element={<Studio />} />
          </Routes>
        </Suspense>
      ) : (
        <div id="disablescroll">
          <ScrollToTop isStudioRoute={isStudioRoute} />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/services" element={<Service />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/clients" element={<Clients />} />
              <Route path='/blog' element={<Blogs />} />
              <Route path={'/blog/:title'} element={<BlogDetail />} />
              <Route path="/careers" element={<Career />} />
              <Route path={'/career-details/:jobPosition'} element={<CareerDetail />} />
              <Route path={'/career-details/:jobPosition/apply'} element={<CareerForm />} />

              {/* portfolio case study pages */}
              <Route path="/portfolio/fragstalk" element={<CaseStudyFragstalk />} />
              <Route path="/portfolio/anandhaas" element={<CaseStudyAnandhaas />} />
              <Route path="/portfolio/fruzo" element={<CaseStudyFruzo />} />
              <Route path="/portfolio/eustress" element={<CaseStudyEustress />} />
              <Route path="/portfolio/acer-electric" element={<CaseStudyAcer />} />
              <Route path="/portfolio/waylon-smith" element={<CaseStudyWaylonSmith />} />
              <Route path="/portfolio/oval" element={<CaseStudyOval />} />
              <Route path="/portfolio/3d/ayurmedix" element={<CaseStudyAyurmedix3d />} />
              <Route path="/portfolio/3d/glosense" element={<CaseStudyGlosense3d />} />
              <Route path="/portfolio/3d/swara" element={<CaseStudySwara3d />} />
              <Route path="/portfolio/3d/mia" element={<CaseStudyMia3d />} />
              <Route path="/portfolio/3d/star-scouts" element={<CaseStudyStarScouts3d />} />
              <Route path="/portfolio/3d/kitchen-culture" element={<CaseStudyKitchenCulture3d />} />
              <Route path="/portfolio/3d/fruzo" element={<CaseStudyFruzo3d />} />
              <Route path="/portfolio/3d/otrix" element={<CaseStudyOtrix3d />} />
              <Route path="/portfolio/3d/aliza" element={<CaseStudyAliza3d />} />
              <Route path="/portfolio/3d/myherb" element={<CaseStudyMyherb3d />} />

              {/* e-commerce portfolios */}
              <Route path="/portfolio/anand-sweets" element={<PortfolioAnandsweets />} />
              <Route path="/portfolio/yogabar" element={<PortfolioYogabar />} />
              <Route path="/portfolio/nourysh" element={<PortfolioNourysh />} />
              <Route path="/portfolio/dr-vaidya" element={<PortfolioDr_vaidya />} />
              <Route path="/portfolio/giver-nutritions" element={<PortfolioGiverNutritions />} />
              <Route path="/portfolio/bayla" element={<PortfolioBayla />} />
              <Route path="/portfolio/chhappanbhog" element={<PortfolioChhappanbhog />} />
              <Route path="/portfolio/prakruti" element={<PortfolioPrakruti />} />
              <Route path="/portfolio/hyfun" element={<PortfolioHyFun />} />
              <Route path="/portfolio/hamdard" element={<PortfolioHamdard />} />
              <Route path="/portfolio/thenga" element={<PortfolioThenga />} />
              <Route path="/portfolio/shistaka" element={<PortfolioShistaka />} />
              <Route path="/portfolio/sportsaber" element={<PortfolioSportSaber />} />
              <Route path="/portfolio/ubar" element={<PortfolioUbar />} />
              <Route path="/portfolio/radhey-sweets" element={<PortfolioRadheySweet />} />
              <Route path="/portfolio/freshleaf" element={<PortfolioFreshLeaf />} />
              <Route path="/portfolio/healthoxide" element={<PortfolioHealthoxide />} />
              <Route path="/portfolio/maa-and-baby" element={<PortfolioMaaNBaby />} />
              <Route path="/portfolio/gogrub" element={<PortfolioGoGrub />} />
              <Route path="/portfolio/mypro" element={<PortfolioMyPro />} />
              <Route path="/portfolio/teatox-life" element={<PortfolioTeaToxLife />} />
              <Route path="/portfolio/ekki-bekki" element={<PortfolioEkkiBekki />} />
              <Route path="/portfolio/aumex" element={<PortfolioAumex />} />
              <Route path="/portfolio/naturare" element={<PortfolioNaturare />} />
              <Route path="/portfolio/neo-roots" element={<PortfolioNeoRoots />} />
              <Route path="/portfolio/within-beauty" element={<PortfolioWithin />} />
              <Route path="/portfolio/uppercase" element={<PortfolioUppercase />} />
              <Route path="/portfolio/om-sweets" element={<PortfolioOmSweets />} />
              <Route path="/portfolio/healing-hands" element={<PortfolioHealingHands />} />
              <Route path="/portfolio/yo-gathiya" element={<PortfolioYoGathiya />} />
              <Route path="/portfolio/kutum-ayurveda" element={<PortfolioKutum />} />
              <Route path="/portfolio/arospice" element={<PortfolioArospice />} />
              <Route path="/portfolio/repeat-gud" element={<PortfolioRepeatGud />} />
              <Route path="/portfolio/nurdle" element={<PortfolioNurdle />} />
              <Route path="/portfolio/technosport" element={<PortfolioTechnoSport />} />
              <Route path="/portfolio/myoa-cookies" element={<PortfolioMyoaCookies />} />
              <Route path="/portfolio/spark-fusion" element={<PortfolioSparkFusion />} />
              <Route path="/portfolio/bontrue-furniture" element={<PortfolioBontrue />} />
              <Route path="/portfolio/bhagavad-gita" element={<PortfolioBhagavadGita />} />
              <Route path="/portfolio/weight-manage" element={<PortfolioWeightManage />} />
              <Route path="/portfolio/agarwalbhavan-sweets" element={<PortfolioAgarwalBhavanSweets />} />
              <Route path="/portfolio/murari-sweets" element={<PortfolioMurariSweet />} />
              <Route path="/portfolio/singlas-sweets" element={<PortfolioSinglas />} />
              <Route path="/portfolio/savani-jewellery" element={<PortfolioSavaniJewellery />} />
              <Route path="/portfolio/mia" element={<PortfolioMia />} />
              <Route path="/portfolio/gpulla-reddy-sweets" element={<PortfolioGPullaReddySweets />} />
              <Route path="/portfolio/chaknow" element={<PortfolioChakNow />} />
              <Route path="/portfolio/my-red-palette" element={<PortfolioRedPalette />} />
              <Route path="/portfolio/outer-world" element={<PortfolioOuterWorld />} />
              <Route path="/portfolio/maison-de-jarin" element={<PortfolioMaisonDeJarin />} />
              <Route path="/portfolio/maadico" element={<PortfolioMaadico />} />
              <Route path="/portfolio/tomahawk" element={<PortfolioTomahawk />} />
              <Route path="/portfolio/ayurmedix" element={<PortfolioAyurmedix />} />
              <Route path="/portfolio/chaykra" element={<PortfolioChaykra />} />
              <Route path="/portfolio/wobb-india" element={<PortfolioWobbIndia />} />
              <Route path="/portfolio/sevpoori" element={<PortfolioSevpoori />} />
              <Route path="/portfolio/great-old-days" element={<PortfolioGreatOldDays />} />
              <Route path="/portfolio/shift-eco" element={<PortfolioShiftEco />} />
              <Route path="/portfolio/glosense" element={<PortfolioGlosense />} />
              <Route path="/portfolio/silverfied" element={<PortfolioSilverfied />} />
              <Route path="/portfolio/elder" element={<PortfolioElder />} />

              {/* ui-ux portfolios */}
              <Route path="/portfolio/ui/teatox-life" element={<UITeatoxLife />} />
              <Route path="/portfolio/ui/the-one" element={<UITheOne />} />
              <Route path="/portfolio/ui/apple-elevators" element={<UIAppleElevators />} />
              <Route path="/portfolio/ui/lycanpay" element={<UILycanPay />} />
              <Route path="/portfolio/ui/healing-hands" element={<UIHealingHands />} />
              <Route path="/portfolio/ui/growth-hive" element={<UIGrowthHive />} />
              <Route path="/portfolio/ui/jammbo" element={<UIJummbo />} />
              <Route path="/portfolio/ui/vijaya-lakshmi-silk" element={<UIVijayaLaxmiSilk />} />

              {/* label-3d portfolios */}
              <Route path="/portfolio/label/shishtaka" element={<LabelShishtaka />} />
              <Route path="/portfolio/label/healing-hands" element={<LabelHealingHands />} />
              <Route path="/portfolio/label/naturare" element={<LabelNaturare />} />
              <Route path="/portfolio/label/mypro" element={<LabelMyPro />} />
              <Route path="/portfolio/label/aumex" element={<LabelAumex />} />
              <Route path="/portfolio/label/teatox-life" element={<LabelTeatoxLife />} />
              <Route path="/portfolio/label/ras-beauty" element={<LabelRas />} />
              <Route path="/portfolio/label/nourysh" element={<LabelNourysh />} />
              <Route path="/portfolio/label/moody" element={<LabelMoody />} />
              <Route path="/portfolio/label/acnex-topical" element={<LabelAcnex />} />
              <Route path="/portfolio/label/anthi-naturals" element={<LabelAnthi />} />
              <Route path="/portfolio/label/terahash-solutions" element={<LabelTerahash />} />
              <Route path="/portfolio/label/smart-mop" element={<LabelCaspianSmartMop />} />
              <Route path="/portfolio/label/kayura-effect" element={<LabelKayura />} />
              <Route path="/portfolio/label/kutum-ayurveda" element={<LabelKutum />} />
              <Route path="/portfolio/label/maadico" element={<LabelMaadico />} />
              <Route path="/portfolio/label/maison-de-jarin" element={<LabelMaisonJarin />} />
              <Route path="/portfolio/label/molecule" element={<LabelMolecule />} />
              <Route path="/portfolio/label/pourd-cocktails" element={<LabelCocktails />} />
              <Route path="/portfolio/label/rare-suga" element={<LabelRareSuga />} />
              <Route path="/portfolio/label/weight-manage" element={<LabelweightManage />} />
              <Route path="/portfolio/label/ras-lipstick" element={<LabelRasLipstick />} />
              <Route path="/portfolio/label/elder" element={<LabelElder />} />
              <Route path="/portfolio/label/oval" element={<LabelOval />} />
              <Route path="/portfolio/label/ras-super-plump" element={<LabelSuperPlump />} />
              <Route path="/portfolio/label/my-herb" element={<LabelMyHerb />} />

              {/* branding portfolios */}
              <Route path="/portfolio/branding/abox" element={<AboxBranding />} />
              <Route path="/portfolio/branding/terahash-solutions" element={<TerahashBranding />} />
              <Route path="/portfolio/branding/nourysh" element={<NouryshBranding />} />
              <Route path="/portfolio/branding/healing-hands" element={<HealinghandBranding />} />
              <Route path="/portfolio/branding/jiva-ayush" element={<JivaAyushBranding />} />
              <Route path="/portfolio/branding/omnes" element={<OmnesBranding />} />
              <Route path="/portfolio/branding/fast-n-fry" element={<FastNFryBranding />} />
              <Route path="/portfolio/branding/velora" element={<VeloraBranding />} />
              <Route path="/portfolio/branding/tokyo-fix" element={<TokyoFixBranding />} />
              <Route path="/portfolio/branding/oval" element={<OvalBranding />} />
              <Route path="/portfolio/branding/70pc" element={<Branding70pc />} />
              <Route path="/portfolio/branding/typical" element={<TypicalBranding />} />

              {/* custom development portfolios */}
              <Route path="/portfolio/dl-films" element={<PortfolioDLFilms />} />
              <Route path="/portfolio/greenfay" element={<PortfolioGreenFay />} />
              <Route path="/portfolio/fast-n-fry" element={<PortfolioFastNFry />} />
              <Route path="/portfolio/fone-network" element={<PortfolioFoneNetwork />} />
              <Route path="/portfolio/aurolab" element={<PortfolioAuroLab />} />
              <Route path="/portfolio/westerville" element={<PortfolioWesterville />} />
              <Route path="/portfolio/bodyart" element={<PortfolioBodyArt />} />
              <Route path="/portfolio/sinclairs-hotels" element={<PortfolioSinclairsHotels />} />
              <Route path="/portfolio/mom-3.0" element={<PortfolioMom />} />
              <Route path="/portfolio/instant-cash-price" element={<PortfolioInstantCashPrice />} />

              {/* webflow portfolios */}
              <Route path="/portfolio/paperclip-and-co" element={<PortfolioPaperClipNCo />} />
              <Route path="/portfolio/codifi" element={<PortfolioCodifi />} />
              <Route path="/portfolio/terahash-solutions" element={<PortfolioTerahash />} />

              <Route path="/international-campaign" element={<InternationalCampaign />} />
              <Route path="/international-campaign-b" element={<InternationalCampaignB />} />
              <Route path="/india-campaign" element={<IndiaCampaign />} />
              <Route path="/shopify-growth-agency" element={<ShopifyFunnle />} />
              <Route path="/shopify-growth-agency/get-audit-your-store" element={<ShopifyFunnleForm />} />

              {/* old services page */}
              <Route path="/services/seo" element={<ServiceSEO />} />
              <Route path="/services/web-development" element={<ServiceWebDevelopment />} />
              <Route path="/services/shopify" element={<ServiceECommerce />} />
              <Route path="/services/for-startup" element={<ServiceForStartup />} />
              <Route path="/services/ab-testing" element={<ServiceAbTesting />} />
              <Route path="/services/3d-render" element={<Service3DRender />} />
              <Route path="/services/visual-identity" element={<ServiceVisualIdentity />} />
              <Route path="/services/ui-ux" element={<ServiceUiUx />} />
              <Route path="/services/web-design" element={<ServiceWebDesign />} />

              {/* new services page */}
              <Route path="/new-services" element={<NewService />} />
              <Route path="/new-services/shopify-development" element={<ShopifyDevelopment />} />
              <Route path="/new-services/shopify-plus-development" element={<ShopifyPlusDevelopment />} />
              <Route path="/new-services/shopify-migration" element={<ShopifyMigration />} />
              <Route path="/new-services/headless-commerce" element={<ShopifyHeadless />} />
              <Route path="/new-services/cro" element={<Cro />} />
              <Route path="/new-services/store-performance" element={<StorePerformance />} />
              <Route path="/new-services/graphic-design" element={<GraphicDesign />} />
              <Route path="/new-services/packaging-design" element={<PackagingDesign />} />
              <Route path="/new-services/3d-rendering" element={<ThreeDRendering />} />
              <Route path="/new-services/motion-graphics" element={<MotionGraphics />} />
              <Route path="/new-services/ui-ux" element={<UiUx />} />
              <Route path="/new-services/visual-identity" element={<Branding />} />
              <Route path="/new-services/web-design" element={<WebDesign />} />
              <Route path="/new-services/ab-testing" element={<AbTesting />} />

              <Route path="/conversion-rate-optimization" element={<ConversionRateOptimization />} />
              <Route path="/legal" element={<LegalBranding />} />
              <Route path="/privacy-policy" element={<PolicyPage />} />
              <Route path="/thank-you" element={<ThankYou />} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>

          <PortfolioRouteSEO />
          <GlobalMediaRevealManager />
          <WhatsAppButton />

        </div>
      )}
    </>
  );
}

export default App;